module.exports = __webpack_public_path__ + "img/soft.883b7165.png";